import { ROUTES } from './routes'

export const SHOP_META = {
  fallbackTitle: 'Shop',
  emptyMessage: 'No products in this category yet.',
  notFoundMessage: 'Category not found.',
} as const

/** Taxon slugs that should also include express-eligible products. */
export const EXPRESS_SHOP_SLUGS = ['60-mins', 'express', '60-min'] as const

/** Taxon slugs that open a dedicated page instead of a product listing. */
export const TAXON_PAGE_ROUTES: Readonly<Record<string, string>> = {
  'bulk-corporate': ROUTES.corporateEnquiry,
}
